import { isMobileSafari } from "react-device-detect";

import type { TIconName } from "components/Icon";

import { getCp1251Byte } from "./string";

export function downloadBlob(blob: any, fileName: string) {
    if (fileName) {
        const newBlob = new Blob([blob]);
        const blobUrl = window.URL.createObjectURL(newBlob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => {
            window.URL.revokeObjectURL(blobUrl);
        }, 1000);
    }
}

/**
 * создаем CSV файл в кодировке CP1251 и отдаем на скачивание
 * @param csvString
 * @param fileName
 */
export function downloadCsv(csvString: string, fileName: string) {
    /*const blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), csvString], {
        type: "text/plain;charset=utf-8",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => {
        window.URL.revokeObjectURL(url);
    }, 1000);*/
    const cp1251Bytes = [];

    for (let i = 0; i < csvString.length; i++) {
        const charCode = csvString.charCodeAt(i);
        const cp1251Byte = getCp1251Byte(charCode);

        if (cp1251Byte !== null) {
            cp1251Bytes.push(cp1251Byte);
        } else {
            // Если символ не найден в таблице, заменяем на '?' или пробел
            // Можно также попытаться обработать суррогатные пары UTF-16
            cp1251Bytes.push(63); // '?' в CP1251
        }
    }

    const blob = new Blob([new Uint8Array(cp1251Bytes)], {
        type: "text/csv;charset=windows-1251;",
    });

    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => {
        URL.revokeObjectURL(a.href);
    }, 1000);
}
export function openBlob(blob: any, withRemoveUrl: boolean = true) {
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    if (isMobileSafari) {
        link.target = "_top";
    } else {
        link.target = "_blank";
    }
    document.body.appendChild(link);
    link.click();
    link.remove();
    if (withRemoveUrl) {
        setTimeout(() => {
            window.URL.revokeObjectURL(blobUrl);
        }, 1000);
    }
}

export function downloadUrl(url: string, fileName?: string) {
    const link = document.createElement("a");
    link.href = url;
    if (fileName) {
        link.setAttribute("download", fileName);
    }

    document.body.appendChild(link);
    link.click();
    link.remove();
}
export function blobToSrc(blob: any) {
    const urlCreator = window.URL || window.webkitURL;
    return urlCreator.createObjectURL(blob);
}
export function dataURLtoBlob(dataURL: any) {
    const binary = atob(dataURL.split(",")[1]);
    const array = [];
    let i = 0;
    const len = binary.length;
    while (i < len) {
        array.push(binary.charCodeAt(i));
        i++;
    }
    return new Blob([new Uint8Array(array)], {
        type: "image/png",
    });
}

export function arrayToCSV(data: string[][], delimiter: string = ";"): string {
    return data
        .map((row) =>
            row
                .map((value) =>
                    // Экранируем данные, если они содержат специальные символы
                    value.includes(delimiter) || value.includes('"')
                        ? `"${value.replace(/"/g, '""')}"`
                        : value
                )
                .join(delimiter)
        )
        .join("\n");
}

export function getFileType(file: any): "image" | "video" | "unknown" {
    if (file) {
        if (typeof file == "object") {
            if (
                (!!file.mimeType && typeof file.mimeType == "string") ||
                (!!file.type && typeof file.type == "string")
            ) {
                const mimeType = file.mimeType ? file.mimeType : file.type;
                if (mimeType.startsWith("image/")) {
                    return "image";
                }
                if (mimeType.startsWith("video/")) {
                    return "video";
                }
            }
            if (file?.originalFileName) {
                return getFileType(file.originalFileName);
            }
        }
        let ext = "";
        if (file?.name) {
            ext = getFileExt(file.name);
        } else if (typeof file == "string" && file.indexOf(".") > -1) {
            ext = getFileExt(file);
        }
        if (ext) {
            switch (ext) {
                case "png":
                case "jpg":
                case "jpeg":
                case "gif":
                case "webp":
                    return "image";
                case "mp4":
                case "webm":
                case "flv":
                    return "video";
            }
        }
    }
    return "unknown";
}
export function getFileExt(fileName: string) {
    const ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
    return ext;
}
export function getFileTypeIconName(filename: string): TIconName {
    const fileExt = getFileExt(filename);
    switch (fileExt) {
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
        case "webp":
            return "image";
        case "mp4":
            return "videocam";
        case "mp3":
            return "music";
        case "pdf":
            return "pdf";
    }
    return "download";
}

export function getFileName(url: string) {
    return url.substring(url.lastIndexOf("/") + 1);
}
export function getFileSize(size: number, localeProps = { minimumFractionDigits: 2 }): string {
    if (!size) {
        return "0 B";
    }
    const i = Math.floor(Math.log(size) / Math.log(1024));
    const value = parseFloat((size / Math.pow(1024, i)).toLocaleString(undefined, localeProps));
    return value.toString() + " " + ["B", "Kb", "Mb", "Gb", "Tb"][i];
}

export async function fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
            resolve(reader.result as string);
        };

        reader.onerror = (error) => reject(error);
    });
}
